import Cookies from "js-cookie";
import ReactGA from "react-ga4";
import { marketingHook } from "../overrides/hooks/init";
import { decodeJwt } from 'jose';
import { hasConsent, isOneTrustEnabled } from "../services/consent";

let initializedAnalyticsKey = null;

// Pageviews are sent explicitly with ReactGA.send; avoid the automatic one from gtag's config.
export const GA_INIT_OPTIONS = { gtagOptions: { send_page_view: false } };

const sendPageView = () => {
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
};


const getCustomUserID = (settings) => {
  const token = Cookies.get("token");
  if (!token)
    return null;
  try {
    const token_values = decodeJwt(token);
    const userField = settings?.analytics?.userField ?? "partner_id";
    return parseInt(token_values[userField]);
  } catch (e) {
    console.debug('ERROR', e);
    return null;
  }
}

const getMaintenanceBypass = () => {
  return Cookies.get("maintenance_bypass");
};

const hasAcceptedCookies = () => {
  if (Cookies.get("rcl_cookies_accepted")) {
    return true;
  }
  return false;
};

const statisticsConsentGiven = () => {
  return hasConsent("statistics");
};

const marketingConsentGiven = () => {
  return hasConsent("marketing");
};

const preferenceConsentGiven = () => {
  return hasConsent("preferences");
};

const acceptCookies = () => {
  Cookies.set("rcl_cookies_accepted", true);
};

const acceptConsentCookies = () => {
  Cookies.set("rcl_consent_given", true);
};

const acceptMarketingCookies = () => {
  Cookies.set("rcl_marketing_consent", true);
};

const acceptPreferencesCookies = () => {
  Cookies.set("rcl_preferences_consent", true);
};

const acceptStatisticCookies = (settings) => {
  if (!settings?.analytics?.key) return;
  ReactGA.initialize(settings.analytics.key, GA_INIT_OPTIONS);
  Cookies.set("rcl_statistics_consent", true);
};

const acceptAllCookies = (settings) => {
  if (settings?.analytics?.key) {
    ReactGA.initialize(settings.analytics.key, GA_INIT_OPTIONS);
  }
  Cookies.set("rcl_cookies_accepted", true);
  Cookies.set("rcl_marketing_consent", true);
  Cookies.set("rcl_consent_given", true);
  Cookies.set("rcl_preferences_consent", true);
  Cookies.set("rcl_statistics_consent", true);
};

const deleteStatisticCookies = (settings) => {
  Cookies.remove("_ga");
  Cookies.remove("_gat");
  Cookies.remove("_gid");
  if (settings?.analytics?.key) {
    window[`ga-disable-${settings?.analytics?.key}`] = true;
  }
};

const updateStatisticScripts = (settings) => {
  // With OneTrust, analytics are handled entirely by the GTM container: GA4 is never loaded.
  if (isOneTrustEnabled()) return;
  if (
    (settings?.features?.analytics ?? false) &&
    (settings?.analytics?.key ?? false) &&
    statisticsConsentGiven()
  ) {
    window[`ga-disable-${settings.analytics.key}`] = false;
    if (initializedAnalyticsKey !== settings.analytics.key) {
      ReactGA.initialize(settings.analytics.key, GA_INIT_OPTIONS);
      initializedAnalyticsKey = settings.analytics.key;
    }
    if (
      settings.features?.analyticsCustomUserID ?? false
    ) {
      const customUserID = getCustomUserID(settings);
      if (customUserID) { ReactGA.set({ userId: customUserID }); }
    }
    sendPageView();
  } else if ((settings?.features?.analytics ?? false) && settings?.analytics?.key) {
    // Without consent (not given yet or withdrawn from the cookie settings) stop GA, without
    // deleting its cookies, which may be shared with other subdomains.
    window[`ga-disable-${settings.analytics.key}`] = true;
  }
};

const updateMarketingScripts = (settings) => {
  if (marketingConsentGiven()) {
    marketingHook();
  }
};

const cookies = {
  getMaintenanceBypass,
  acceptConsentCookies,
  statisticsConsentGiven,
  marketingConsentGiven,
  preferenceConsentGiven,
  deleteStatisticCookies,
  acceptStatisticCookies,
  updateStatisticScripts,
  acceptMarketingCookies,
  updateMarketingScripts,
  acceptPreferencesCookies,
  acceptAllCookies,
  hasAcceptedCookies,
  acceptCookies
};

export default cookies;
